export function toolbarClose() {
    return {
        restrict: 'E',
        scope: {},
        controller: ToolbarCloseController,
        controllerAs: 'vm',
        templateUrl: 'app/components/toolbar-close.directive.html'
    };
}

class ToolbarCloseController{

    constructor($window) {
        this.$window = $window;
    }

    close(){
        this.$window.close();
    }
}
ToolbarCloseController.$inject = ['$window'];
